import React from 'react';
import { Tooltip } from '@cvent/carina/components/Tooltip';
import { HelpCircleIcon } from '@cvent/carina/components/Icon';
import { Placements } from '@cvent/carina/components/Popper';
import { useTranslate } from 'nucleus-text';

interface CoreTooltipProps {
  testID: string;
}

export const CoreTooltip = ({ testID }: CoreTooltipProps): JSX.Element => {
  const { translate } = useTranslate();

  return (
    <Tooltip
      testID={`${testID}_tooltip`}
      placement={Placements.bottom}
      trigger={
        <a>
          <HelpCircleIcon />
        </a>
      }
      text={translate('form_core_help_text')}
      portal
    />
  );
};

export default Tooltip;
